import BaseApi from '../base';

class HealthApi extends BaseApi {
  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getElements(token) {
    return this.makeRequest(this.METHOD_GET, '', token);
  }

  /**
   * @param {string} token
   * @param {string} user
   * @returns {Promise<*>}
   */
  async getState(token, user) {
    return this.makeRequest(this.METHOD_GET, `state?user=${user}`, token);
  }

  /**
   * @param {string} token
   * @param data
   * @returns {Promise<*>}
   */
  async addState(token, data) {
    return this.makeRequest(this.METHOD_POST, 'state', token, data);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getContent(token) {
    return this.makeRequest(this.METHOD_GET, 'content', token);
  }
}

export default HealthApi;
